import { combineReducers } from "redux";
import authReducer from "./auth";
import banksReducer from "./banks";
import rtpReducer from "./rtp";
import reusableRtpReducer from "./reusableRtp";

const rootReducer = combineReducers({
  auth: authReducer,
  rtp: rtpReducer,
  banks: banksReducer,
  reusableRtp: reusableRtpReducer,
});

export { rootReducer };

export default rootReducer;
